// extracted by mini-css-extract-plugin
module.exports = {"ring":"ProgressRing_ring__hzLnO","text":"ProgressRing_text__4Acs_","overflow":"ProgressRing_overflow__ADdSW"};